"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectSpectrometer = exports.emptyAnchor = exports.injectScript = void 0;
const cathode_versions_javascript_1 = require("cathode-versions-javascript");
const metrics_config_1 = require("./metrics_config");
const updateIfTruthy = (value, target, key) => {
    if (value) {
        target[key] = value;
    }
};
exports.injectScript = (anchor) => (scriptText) => {
    /*
      The cathode script output is a fully formed script tag string '<script>...</script>'

      We'll do our best to parse the script, create an element and inject it into our html document head
      where it will be executed and any metrics concepts will be loaded.

      The DOMParser doesn't like to inject executable script tags which is why we can't parse and insert
      directly. Instead we parse the element then lift and shift to a new element that gets inserted.
      https://stackoverflow.com/questions/28112807/why-script-elements-created-through-domparser-do-not-execute

      Further, the script content may contain some characters ('&' '<' '>') that throw off the 'text/xml' parser which is
      why we're parsing as 'text/html' and extracting the script element from that complete html document.
  */
    const parsedScript = new DOMParser().parseFromString(scriptText, 'text/html').getElementsByTagName('script')[0];
    const newScript = document.createElement('script');
    updateIfTruthy(parsedScript === null || parsedScript === void 0 ? void 0 : parsedScript.type, newScript, 'type');
    updateIfTruthy(parsedScript === null || parsedScript === void 0 ? void 0 : parsedScript.src, newScript, 'src');
    updateIfTruthy(parsedScript === null || parsedScript === void 0 ? void 0 : parsedScript.innerHTML, newScript, 'innerHTML');
    anchor.appendChild(newScript);
};
exports.emptyAnchor = (anchor) => {
    while (anchor.firstChild) {
        anchor.removeChild(anchor.firstChild);
    }
};
exports.injectSpectrometer = (anchor, config) => {
    const cathodeConfig = {
        realm: config.realm,
        siteName: config.site,
        appName: metrics_config_1.getAppStageName(config),
    };
    exports.emptyAnchor(anchor);
    const { boomerangLoaderScript, listenerScripts, cathodeScript } = cathode_versions_javascript_1.getSpectrometerScriptTags(cathodeConfig, metrics_config_1.isProdSpectrometer(config));
    [boomerangLoaderScript, listenerScripts, cathodeScript].forEach(exports.injectScript(anchor));
};
